import { ArrowDownRight, ArrowUpRight, MessageSquareText, PhoneCall } from "lucide-react";
import { useReveal } from "./useReveal";

const Hero = ({ settings }) => {
  const [ref, revealClass] = useReveal();
  const phone = settings.phone.replace(/[^0-9+]/g, "");
  const lines = settings.hero_lines || ["Architectural hardwood.", "Milled for generations.", "Made for your home."];

  return (
    <section className="hero-section section-wrap" ref={ref} data-testid="hero-section">
      <div className="hero-contact-ribbon" data-testid="hero-contact-ribbon">
        <a className="hero-start-button" href={`tel:${phone}`} data-testid="hero-get-started-button">Free Estimate <ArrowUpRight size={18} /></a>
      </div>
      <div className={`hero-grid ${revealClass}`}>
        <div className="hero-copy">
          <div className="eyebrow-row"><span className="signal-dot" /><p className="eyebrow">PA / DE / NJ · EST. 2008</p></div>
          <h1 data-testid="hero-main-heading">
            {lines.map((line, index) => <span className="hero-line-mask" key={line}><span className="hero-line" style={{ animationDelay: `${0.16 + index * 0.14}s` }}>{line}</span></span>)}
          </h1>
          <p className="hero-intro">At Sosa’s Hardwood Floors, we specialize in dustless hardwood floor refinishing, offering a cleaner and more efficient alternative to traditional sanding methods. Contact us for a free estimate. We specialize in quality and care for your floors.</p>
          <div className="hero-actions">
            <a className="button button-primary" href={`tel:${phone}`} data-testid="hero-call-now-button"><PhoneCall size={17} /> Call {settings.phone}</a>
            <a className="text-link" href={`sms:${phone}`} data-testid="hero-text-button"><MessageSquareText size={17} /> Text us your floor photos <ArrowDownRight size={16} /></a>
          </div>
          <div className="hero-footnote" data-testid="hero-service-note"><span>01</span><p>We serve homeowners across Pennsylvania, Delaware and New Jersey.</p></div>
        </div>
        <div className="hero-visual">
          <div className="hero-photo-frame">
            <img className="hero-photo" src={settings.hero_image_url} alt="Warm architectural interior with finished hardwood floors" fetchPriority="high" />
            <div className="photo-coordinate">REAL PROJECT <span>PENNSYLVANIA</span></div>
          </div>
          <div className="hero-identity-row">
            <img className="hero-logo" src={settings.logo_url} alt={`${settings.company_name} logo mark`} data-testid="hero-dynamic-logo" />
            <div className="eyebrow">Real project</div><p className="hero-tagline">{settings.tagline}</p>
          </div>
        </div>
      </div>
      <a className="scroll-cue" href="#craft" data-testid="hero-scroll-link"><span>See our services</span><ArrowDownRight size={18} /></a>
    </section>
  );
};

export default Hero;
